import { graphql, PageProps } from 'gatsby'
import * as React from 'react'
import { SiteSeo } from '../../components/seo/seo.component'
import WidgetTabs from '../../components/widget-tabs/widget-tabs.component'
import WidgetTags from '../../components/widget-tags/widget-tags.component'
import WidgetTocSection from '../../components/widget-toc-section/widget-toc-section.component'
import ConfigurePageLayout from '../../layouts/page/page-layout-configure.component'
import { PageNavigation, SideNav } from '../../types/navigation.types'

export type PageTemplateContext = {
  id: string
  sideNavs?: SideNav[]
  next?: PageNavigation
  prev?: PageNavigation
  sandboxKeys: string[]
}

export type PageTemplateProps = PageProps<GatsbyTypes.getPageDetailsQuery, PageTemplateContext>

const PageTemplate: React.FC<PageTemplateProps> = ({ data, pageContext }) => {
  const { contentfulPage: content } = data
  const firstNodeWithHeading = (content?.sections || []).find(
    section => section?.__typename === 'ContentfulHeading' && !section.slug && (section.variant === 'h1' || section.variant === 'h2'),
  ) as GatsbyTypes.headingFragment
  return (
    <ConfigurePageLayout
      sideNavs={pageContext.sideNavs}
      next={pageContext.next}
      prev={pageContext.prev}
      slug={content?.fields?.slug}
      type={content?.type}
      sandboxes={data.sandboxes?.nodes}
    >
      <SiteSeo title={data.contentfulPage?.seoTitle} description={data.contentfulPage?.seoDescription?.seoDescription} />
      <article className="article">
        <WidgetTags tags={content?.tags} />
        <WidgetTocSection nodes={content?.sections} renderToc={content?.generateSectionToc} tocHeading={firstNodeWithHeading?.text} />
        <WidgetTabs tabs={content?.tabs} />
      </article>
    </ConfigurePageLayout>
  )
}

export default React.memo(PageTemplate)

export const query = graphql`
  query getPageDetails($id: String!, $sandboxKeys: [String!]) {
    contentfulPage(id: { eq: $id }) {
      ...page
    }
    sandboxes: allMdx(filter: { frontmatter: { sandboxKey: { in: $sandboxKeys } } }) {
      nodes {
        id
        frontmatter {
          sandboxKey
        }
        body
      }
    }
  }
`
